import CheckInQrCode from "./CheckInQrCode";

export default CheckInQrCode;
